import React, { useEffect, useState } from "react";
import { FmIcon } from "..";
import { useTheme } from "../../Hooks";

import useStyles from "./FmBlackPopup.style";

interface BlackPopupProps {
  text: string;
  onActionText?: string;
  onAction?: () => void;
  onClose: () => void;
  onCloseWithPress?: () => void;
  snackbar?: boolean;
}

const snackbarTime = 500;

const FmBlackPopup = ({ text, onActionText, onAction, onClose, snackbar = false, onCloseWithPress }: BlackPopupProps) => {
  const theme = useTheme();
  const classes = useStyles();

  useEffect(() => {
    snackbar &&
      setTimeout(() => {
        onClose();
      }, snackbarTime);
  }, []);
  return (
    <div className={classes.container}>
      <div className={classes.leftSide}>
        <div className={classes.icon_container}>
          <FmIcon url={theme.images.vi_popup} />
        </div>
        <div>{text}</div>
      </div>

      <div className={classes.rightSide}>
        <div className={classes.onActionText} onClick={onAction}>
          {onActionText}
        </div>
        <div className={classes.icon_container} onClick={onCloseWithPress ? onCloseWithPress : onClose}>
          <FmIcon url={theme.images.close_popup} />
        </div>
      </div>
    </div>
  );
};

export default FmBlackPopup;
